import autoBind from 'auto-bind'

/**
 * BaseClass for Router files in REST APIs
 *
 * @class
 * @classdesc BaseClass for Router files in REST APIs
 */
export abstract class BaseService {
  constructor() {
    autoBind(this)
  }
}
